import * as React from 'react';
export const terminalSvg = React.forwardRef(function terminalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h6ZM5 1.5A1.5 1.5 0 0 0 3.5 3v10A1.5 1.5 0 0 0 5 14.5h6a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 11 1.5H5Zm4.735 4.57a.75.75 0 0 1 1.044 1.076l-3.066 2.971a.75.75 0 0 1-1.085-.042L5.239 8.497a.75.75 0 1 1 1.126-.99l.87.985 2.5-2.423Z',
    }),
  );
});
terminalSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var terminal = {
  category: 'icon',
  colorable: true,
  name: 'terminal',
  svg: terminalSvg,
};
